var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaSystemSpeakers(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_843_44596)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.78636 31.0563H7.66136V1.87122H24.3376V31.0563H26.2126V-0.00378418H5.78636V31.0563Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4725 30.1188H4.52696V31.9938H27.4725V30.1188Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4116 31.0658V25.2616C11.4116 22.7278 13.4656 20.6737 15.9995 20.6737C18.5333 20.6737 20.5874 22.7278 20.5874 25.2616V31.0658H22.4624V25.2616C22.4624 21.6923 19.5688 18.7987 15.9995 18.7987C12.4301 18.7987 9.53657 21.6923 9.53657 25.2616V31.0658H11.4116Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0991 25.2616C13.0991 26.8635 14.3976 28.162 15.9995 28.162C17.6013 28.162 18.8998 26.8635 18.8998 25.2616C18.8998 23.6598 17.6013 22.3613 15.9995 22.3613C14.3976 22.3613 13.0991 23.6598 13.0991 25.2616ZM15.9995 26.287C15.4332 26.287 14.9741 25.8279 14.9741 25.2616C14.9741 24.6953 15.4332 24.2363 15.9995 24.2363C16.5658 24.2363 17.0248 24.6953 17.0248 25.2616C17.0248 25.8279 16.5658 26.287 15.9995 26.287Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.52097 10.3454C9.52097 13.9233 12.4215 16.8239 15.9995 16.8239C19.5774 16.8239 22.478 13.9233 22.478 10.3454C22.478 6.76743 19.5774 3.86688 15.9995 3.86688C12.4215 3.86688 9.52097 6.76743 9.52097 10.3454ZM15.9995 14.9489C13.457 14.9489 11.396 12.8878 11.396 10.3454C11.396 7.80296 13.457 5.74188 15.9995 5.74188C18.5419 5.74188 20.603 7.80296 20.603 10.3454C20.603 12.8878 18.5419 14.9489 15.9995 14.9489Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2221 10.3454C13.2221 11.8792 14.4655 13.1228 15.9995 13.1228C17.5334 13.1228 18.7769 11.8793 18.7769 10.3454C18.7769 8.81151 17.5334 7.56795 15.9995 7.56795C14.4655 7.56795 13.2221 8.81153 13.2221 10.3454ZM15.9995 11.2478C15.5011 11.2478 15.0971 10.8438 15.0971 10.3454C15.0971 9.84698 15.5011 9.44295 15.9995 9.44295C16.4979 9.44295 16.9019 9.847 16.9019 10.3454C16.9019 10.8438 16.4979 11.2478 15.9995 11.2478Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9995 15.0575H29.2543V16.9325H31.9995V15.0575Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.4708 10.8276L27.5296 12.7687L28.8555 14.0946L30.7966 12.1534L29.4708 10.8276Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.7966 19.8366L28.8555 17.8955L27.5296 19.2213L29.4708 21.1624L30.7966 19.8366Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-0.000488281 16.9325H2.74464V15.0575H-0.000488281V16.9325Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.20239 12.1534L3.14351 14.0946L4.46934 12.7687L2.52821 10.8276L1.20239 12.1534Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.52821 21.1624L4.46934 19.2213L3.14351 17.8955L1.20239 19.8366L2.52821 21.1624Z",
    fill: "#222222"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_843_44596"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaSystemSpeakers);
export default __webpack_public_path__ + "static/media/paSystemSpeakers.048a824f365e9bdab7ba0a1596b3cffb.svg";
export { ForwardRef as ReactComponent };